export default function TransactionPointModel() {
    return {
        id:null,
        type_name:null,
        descriptions:null
    };
}
